<template>
  <div class="upload_wrapper">
    <el-upload
      class="avatar-uploader"
      :data={folderName}
      :action="picUrl + 'upload/upload'"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload">
      <el-button slot="trigger" type="primary">{{text}}</el-button>
    </el-upload>
  </div>

</template>
<script>
  import {mapGetters} from 'vuex'
  import config from '@/config'

  export default {
    props: {
      folderName: {},
      appendUrl: {
        default: ''
      },
      text: {
        default: ''
      },
      appendName: {
        default: ''
      },
      width: {
        default: ''
      },
      height: {
        default: 120
      }
    },
    data () {
      return {
        fileName: '',
        picUrl: config.baseUrl
      }
    },
    watch: {
      appendName (val1) {
        if (val1) {
          console.log(val1)
          this.fileName = val1
        }
      }
    },
    created () {
      console.log(33, this.picAddr)
      if (this.appendUrl) {
        this.fileUrl = this.picAddr+this.appendUrl
      } else {
        this.fileUrl = ''
      }
    },

    activated() {
      console.log(this.appendUrl)
      if (this.appendUrl) {
        this.fileUrl = this.picAddr+this.appendUrl
      } else {
        this.fileUrl = ''
      }
      this.fileName = this.appendName
    },
    methods: {
      handleAvatarSuccess (res, file) {
        this.fileUrl = file.response.file.url
        this.fileName = file.response.file.fileName
        this.$emit('changed', this.fileUrl.replace(this.picAddr, ''),this.fileName)
      },
      beforeAvatarUpload (file) {
        console.log(222)
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          // this.$message.error('上传图片大小不能超过 2MB!')
        }
        // return isLt10M
        return
      }
    },
    computed: {
      headers () {
        return {
          Authorization: 'Bearer ' + window.localStorage.getItem('token')
        }
      },
      ...mapGetters(['picAddr'])
    }

  }
</script>
<style lang="scss" scoped>
  .upload_wrapper {
  }
</style>

